export default __webpack_public_path__ + "static/media/python12.659b22b6.png";